// exports.server = "http://localhost:8000"
exports.server = "https://api.docity.co"